export default {
	name: "TextBlock",
	data() {
		return {
			editedSource: null
		}
	},
	props: [
		"source"
	],
	created() {
		
	},
	watch: {},
	computed: {},
	mounted(){
		this.identifyVideo();
	},
	methods: {
		identifyVideo() {
			let videoIni = this.source.indexOf("[embed]")
			let videoEnd = this.source.indexOf("[/embed]")
			
			let videoTag = this.source.substring(videoIni, videoEnd + 8)
			let videoUrl = this.source.substring(videoIni + 7, videoEnd)
			
			let template = '<div class="video__wrapper"><iframe class="video" src="' + videoUrl + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>'
			
			if (videoIni !== -1) {
				this.editedSource = this.source.replace(videoTag, template);
			}
			else
				this.editedSource = this.source;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/text/text.block.js